import { render, staticRenderFns } from "./InterfaceSettingsColors.vue?vue&type=template&id=1858e3c6&scoped=true"
import script from "./InterfaceSettingsColors.vue?vue&type=script&lang=js"
export * from "./InterfaceSettingsColors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1858e3c6",
  null
  
)

export default component.exports